/* Street Lines — add to cart.
 *
 * A deliberately small alternative to Dawn's <product-form>, which requires a
 * specific DOM (spinner node, span inside the button, error wrapper) that our
 * card markup does not have. This posts to /cart/add.js, asks Shopify to
 * re-render the cart-icon-bubble section in the same round trip, and swaps the
 * header count in place.
 *
 * Without JS the form still works: it posts normally and lands on /cart.
 */
if (!customElements.get('sl-add-to-cart')) {
  customElements.define(
    'sl-add-to-cart',
    class SlAddToCart extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        if (!this.form || !this.button) return;

        this.idleLabel = this.button.dataset.labelIdle || this.button.textContent.trim();
        this.doneLabel = this.button.dataset.labelDone || 'PŘIDÁNO';
        this.busyLabel = this.button.dataset.labelBusy || 'PŘIDÁVÁM…';
        this.errorLabel = this.button.dataset.labelError || 'ZKUS TO ZNOVU';

        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      setLabel(text, state) {
        this.button.textContent = text;
        this.button.dataset.state = state || '';
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.button.disabled) return;

        this.button.disabled = true;
        this.setLabel(this.busyLabel, 'busy');

        const body = new FormData(this.form);
        // Ask for the updated cart bubble alongside the add, so the header
        // count never needs a second request.
        body.append('sections', 'cart-icon-bubble');
        body.append('sections_url', window.location.pathname);

        try {
          const response = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          });
          const data = await response.json();

          if (!response.ok) {
            // Shopify returns { description } for things like out of stock.
            this.setLabel(this.errorLabel, 'error');
            this.announce(data.description || data.message || '');
            this.resetSoon();
            return;
          }

          this.updateCartCount(data.sections && data.sections['cart-icon-bubble']);
          this.setLabel(this.doneLabel, 'done');
          this.announce(this.doneLabel);
          document.dispatchEvent(new CustomEvent('sl:cart:added', { detail: { item: data } }));
          this.resetSoon();
        } catch (error) {
          this.setLabel(this.errorLabel, 'error');
          this.resetSoon();
        }
      }

      updateCartCount(sectionHtml) {
        const target = document.getElementById('cart-icon-bubble');
        if (!target || !sectionHtml) return;

        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const source = parsed.querySelector('.shopify-section') || parsed.body;
        target.innerHTML = source.innerHTML;
      }

      announce(message) {
        if (!message) return;
        let live = this.querySelector('[data-sl-live]');
        if (!live) {
          live = document.createElement('span');
          live.className = 'visually-hidden';
          live.setAttribute('role', 'status');
          live.setAttribute('data-sl-live', '');
          this.appendChild(live);
        }
        live.textContent = message;
      }

      resetSoon() {
        clearTimeout(this._resetTimer);
        this._resetTimer = setTimeout(() => {
          this.button.disabled = false;
          this.setLabel(this.idleLabel, '');
        }, 2200);
      }
    }
  );
}
